import { createAdvancedOrderProduct } from "./global";

function moveProductElements(product) {
    const prices = product.find('.prices')
    const shipping = $('<div class="shipping"></div>').insertAfter(prices);
    const availability = product.find('.ratings-wrapper .availability')
    const code = product.find('.p .p-code')
    const freeShipping = product.find('.flags .flag-freeshipping')
    const shippingLabel = product.find('.shipping .flag-shipping')

    code.appendTo(prices)

    if (freeShipping.length) {
        freeShipping.appendTo(shipping);
    } else if (!shippingLabel.length && !product.find('.shipping .flag-freeshipping').length) {
        $('<span class="flag flag-shipping">Versand ab 79 Kč</span>').appendTo(shipping);
    }

    availability.appendTo(shipping)
}

function addImageAndPriceToAdvancedOrder() {
    $(document).on('click', '.product .btn.add-to-cart-button', function () {
        const product = $(this).closest('.product')
        const image = product.find('.image img').attr('src')
        const price = product.find('.price.price-final').text()
        const url = product.find('.name').attr('href')
        const availability = product.find('.availability span').first().text().trim();

        createAdvancedOrderProduct({ image, price, url, availability })
    })
}

export const transformProducts = () => {
    const products = $('.products:not(#productsTop) .product')

    if (products.length) {
        products.each(function () {
            const product = $(this)

            // Přepozicování elementů
            moveProductElements(product)
        })

        // Přidání obrázku a ceny do mezikošíku
        addImageAndPriceToAdvancedOrder()
    }
}

export function initProducts() {
    transformProducts()

    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
        transformProducts()
    })
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
        transformProducts()
    })
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
        transformProducts()
    })
}
